import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

// Plays a muted, looping <video> only while it's on screen, so a page of clips stays light.
// Users who ask for reduced motion see the first frame instead.
@Directive({
  selector: 'video[appPlayInView]',
})
export class PlayInViewDirective implements OnInit, OnDestroy {
  private observer?: IntersectionObserver;

  constructor(private el: ElementRef<HTMLVideoElement>) {}

  ngOnInit(): void {
    const video = this.el.nativeElement;
    // Angular doesn't reflect [muted] to the property, and browsers only autoplay muted video.
    video.muted = true;
    video.loop = true;
    video.playsInline = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      video.preload = 'metadata';
      return;
    }

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }, { threshold: 0.5 });
    this.observer.observe(video);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
